class SKToggle {
    constructor() {
        this._init()
    }
    _init() {
        document.querySelectorAll('[data-sk-toggle]').forEach(root => {

            root.querySelectorAll('[data-sk-toggle-src]').forEach(el => {
                el.addEventListener('click', (e) => {
                    const action = e.target.closest('[data-sk-toggle-src-action]')
                    if (!action) {
                        return;
                    }

                    e.preventDefault()
                    el.classList.toggle('hidden');

                    root.querySelectorAll(['[data-sk-toggle-dst]']).forEach(el2 => {
                        el2.classList.toggle('hidden');
                    });
                })
            })

        })
    }
}

export default SKToggle